import { usesPermissionSet } from './membership';

const listGetters = [
  'getAllConversations',
  'getFilteredConversations',
  'getMineChats',
  'getUnAssignedChats',
  'getParticipatingChats',
  'getAllStatusChats',
];

export const permissionSetConversationLists = getters =>
  Object.fromEntries(
    listGetters.map(name => [
      name,
      (state, localGetters, rootState, rootGetters = {}) => {
        const account = rootGetters.getCurrentUser?.accounts?.find(
          item => Number(item.id) === Number(rootGetters.getCurrentAccountId)
        );
        const scopedState = usesPermissionSet(account)
          ? {
              ...state,
              allConversations: state.allConversations.filter(
                conversation => conversation.permission_set_list_access === true
              ),
            }
          : state;
        return getters[name](scopedState, localGetters, rootState, rootGetters);
      },
    ])
  );
